import { useState } from 'react';
import { Box, Typography, Divider, RadioGroup, Radio, ConfirmationDialog, Button } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function CustomRadioGroup({ selected, onChange, options }) {
  const isMobile = useIsMobile();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleChange = (newValue) => {
    if (newValue === "Hidden") {
      setConfirmOpen(true);
      return;
    }
    onChange(newValue);
  };

  const hiddenOptionConfirmed = () => {
    onChange("Hidden");
  };

  return (<>
    <RadioGroup value={selected} onChange={(e) => handleChange(e.target.value)}>
      {options.map(({ value, title, description, privacyIcon }) => (
        <Box
          key={value}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: 'transparent',
            WebkitTapHighlightColor: 'transparent',
            '&:focus': {
              outline: 'none', 
            },
          }}
          onClick={() => handleChange(value)}
        >
          {privacyIcon || null}

          <Box mt={1} sx={{ width: '100%', marginLeft: privacyIcon ? 1 : 0 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant={isMobile ? "subtitle1" : "body2"} fontWeight={600}>
                {title}
              </Typography>

              <Radio
                checked={value === selected}
                value={value}
                onClick={(e) => e.stopPropagation()}
                sx={{
                  p: 0,
                  mx: 0,
                  '& .MuiSvgIcon-root': { fontSize: 12 },
                }}
              />
            </Box>

            <Typography variant={isMobile ? "body2" : "body3"} color="text.secondary">
              {description}
            </Typography>

            <Divider sx={{ mt: 1 }} />
          </Box>
        </Box>
      ))}
    </RadioGroup>

    <ConfirmationDialog
        open={confirmOpen}
        title="Are you sure?"
        content="This will make your profile invisible. Are you sure you don't want to meet other travellers?"
        onCancel={() => setConfirmOpen(false)}
        onConfirm={() => {
            setConfirmOpen(false);
            hiddenOptionConfirmed();
        }}
        confirmText="Confirm"
        />
  </>);
}
